const UTF16toUTF8 = (UTF16String) => decodeURIComponent(UTF16String.split('')
    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
    .join(''));
const decodeUrlQuery = ({ urlQuery, parametersToBeDecoded = [] }) => {
    const decodedUrl = Object.assign({}, urlQuery);
    for (const param of parametersToBeDecoded) {
        let value = decodedUrl[param];
        try {
            value = UTF16toUTF8(universalDecode(value));
        }
        catch (error) {
            // Not Base64 encoded
        }
        decodedUrl[param] = value;
    }
    return decodedUrl;
};
function universalDecode(str) {
    if (__IN_SERVER__) {
        return Buffer.from(str, 'base64').toString('latin1');
    }
    else {
        return atob(str);
    }
}
export default decodeUrlQuery;
//# sourceMappingURL=decodeUrlQuery.js.map